<template>
  <span>
    <b-button variant="-primary" size="-small btn--fixed" @click="handleOpenSlicer">{{$t('apps.editor.slice')}}</b-button>
  </span>
</template>

<script>

  export default {
    name: 'file-slice-button',
    props: {
      fileId: {
        type: [Number, String],
        required: true
      }
    },
    data() {
      return {
        slicer3Show: false
      }
    },
    methods: {
      handleOpenSlicer() {
        window.vueOpenSlicer3(this.fileId);
      }
    }
  }
</script>
